import { Dispatch, SetStateAction } from 'react'
import { Observable } from 'rxjs'
import { APIUserResponse } from '../models'
import store from '../store'
import { useService, useServiceBatch } from '../utils/hook'
import request, { RequestResponse } from '../utils/request'
import { ActionType as ErrorActions } from '../store/error/actions'
import { buildQueryFromObject } from '../utils/parser/query'
import { observableFromAbortableRequest } from '../utils/map'

export function useUserMe(): [
  RequestResponse<APIUserResponse> | undefined,
  Dispatch<SetStateAction<Record<string, string | number | undefined>>>,
  Observable<RequestResponse<APIUserResponse>> | undefined
] {
  return useService<APIUserResponse, Record<string, any>>(
    () => request.getRequest('api/users/me')(),
    {},
    (error) => {
      if (error instanceof DOMException) return
      store.dispatch({
        type: ErrorActions.SET_BY_STATUS,
        payload: { statusCode: error.status, message: error.message }
      })
    }
  )
}
export function useUsers<
  Query extends Record<string, string | number | undefined>
>(
  initialQuery: Query
): [
  RequestResponse<APIUserResponse[]> | undefined,
  Dispatch<SetStateAction<Query>>,
  Observable<RequestResponse<APIUserResponse[]>> | undefined
] {
  return useService(
    (query) => request.getRequest(buildQueryFromObject(query, 'api/users/?'))(),
    initialQuery,
    (error) => {
      if (error instanceof DOMException) return
      store.dispatch({
        type: ErrorActions.SET_BY_STATUS,
        payload: { statusCode: error.status, message: error.message }
      })
    }
  )
}
export function useAllUsersInBatch<
  T extends { page: number } & Record<string, string | number | undefined>
>(
  query: T
): [
  APIUserResponse[] | undefined,
  Dispatch<SetStateAction<T>>,
  Observable<APIUserResponse[]> | undefined
] {
  return useServiceBatch<APIUserResponse, T>('api/users/?', query)
}
export function updateUserPreference(
  name: string,
  value: string
): Observable<unknown> {
  return observableFromAbortableRequest(
    request.patchRequest(
      `api/userpreferences/${name}/`,
      {
        value: value
      },
      {
        'content-type': 'application/json'
      }
    )()
  )
}
